export type SearchConfig = {
  host: string;
  platform: "obx" | "wordpress";
};

/**
 * Builds the "see all news that mentions <institution>" search URL.
 *
 * OBX search takes a bare, lower-cased term via /search/?k=; the legacy
 * WordPress search keeps the term quoted so it matches as a phrase rather than
 * an OR over its words. Both encode the term — an institution name containing
 * "&" or "#" would otherwise split or truncate the query string.
 */
export const buildSearchUrl = (
  institutionName: string,
  { host, platform }: SearchConfig
): string => {
  const term = institutionName.trim();

  return platform === "obx"
    ? `${host}/search/?k=${encodeURIComponent(term.toLowerCase())}`
    : `${host}/?s=${encodeURIComponent(`"${term}"`)}`;
};
